<template>
  <div class="order-complete-boleto">
    <template v-if="paymentStatus == 'loading'">
      <i class="fa fa-spin mdi mdi-loading fa-2x"></i>
    </template>
    <template v-if="paymentStatus == 'error'">
      <p>Não foi possível gerar o código para pagamento.</p>
      <button
        class="btn btn-primary btn-sm"
        @click="
          paymentStatus = 'loading';
          getQrCode();
        "
      >
        Tentar novamente
      </button>
    </template>
    <template v-else-if="paymentStatus == 'pending'">
      <div class="ocb-code-area">
        <p>
          <i class="fa-brands fa-pix fa-3x" style="color: #00bfad"></i>
        </p>
        <h5 class="ocb-title">Escaneie o QR code com o app do seu banco</h5>

        <div class="qrcode">
          <qrcode
            v-if="qrCode"
            :value="qrCode"
            :options="{ width: 200 }"
          ></qrcode>
          <div
            v-else
            style="width: 200px; height: 200px; background-color: #efefef"
          ></div>
        </div>

        <button
          class="btn btn-primary btn-sm"
          :disabled="!hasQrCode"
          @click="copyQrContentToClipboard()"
        >
          <i v-if="!hasQrCode" class="fa fa-spinner fa-spin"></i> Ou copie o
          código
        </button>
      </div>

      <hr />

      <b>Para pagar:</b>
      <ul style="padding: 0; margin: 0; list-style: none; padding-top: 10px">
        <li>
          <small>1. Acesse o app do seu banco</small>
        </li>
        <li>
          <small>2. Escolha pagar com PIX</small>
        </li>
        <li>
          <small>3. Cole o código de pagamento ou escaneie o QR code</small>
        </li>
      </ul>
      <hr />

      <small
        >Pague até {{ format(new Date(qrExpiration), "dd/MM/yy HH:mm") }}</small
      >
    </template>
    <template
      v-else-if="paymentStatus == 'cancelled' || paymentStatus == 'denied'"
    >
      <P>Pagamento não aprovado.</P>
    </template>
    <template v-else-if="paymentStatus == 'approved'">
      <p>Pagamento aprovado.</p>
    </template>
    <template v-else-if="paymentStatus == 'expired'">
      <p>Pagamento expirado.</p>
      <p>
        <small
          >Se você já fez o pagamento, é só aguardar. Caso não tenha pago, será
          preciso fazer um novo pedido.</small
        >
      </p>
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import qrcode from "@chenfengyuan/vue-qrcode";
import { format, isAfter } from "date-fns";
import bus from "@/utils/events/bus";

export default {
  name: "OrderCompletePix",
  components: {
    qrcode,
  },
  props: {
    pedidoId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      qrCode: null,
      paymentStatus: "loading",
      qrExpiration: null,
      checkInterval: null,
    };
  },
  computed: {
    hasQrCode() {
      return !!this.qrCode || (!this.qrCode && this.paymentStatus != "pending");
    },
  },
  mounted() {
    this.getQrCode();

    this.checkInterval = setInterval(() => {
      if (
        // this.qrExpiration &&
        // isAfter(new Date(), new Date(this.qrExpiration)) &&
        document.visibilityState === "visible" &&
        this.paymentStatus == "pending"
      ) {
        this.getQrCode();
      }

      if (this.paymentStatus != "pending" && this.paymentStatus != "error") {
        clearInterval(this.checkInterval);
      }
    }, 30000);

    window.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);

    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }

    window.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },

  methods: {
    format,
    handleVisibilityChange() {
      if (
        document.visibilityState === "visible" &&
        this.paymentStatus === "pending"
      ) {
        this.getQrCode();
      }
    },
    async getQrCode() {
      clearTimeout(this.timeout);
      try {
        const url = `${process.env.VUE_APP_ECOMMERCE}ec/pedido/${this.pedidoId}/pix`;

        const { data } = await dpcAxios.connection().get(url);
        if (!data.error) {
          this.qrCode = data.qr_code;
          this.paymentStatus = data.payment_status;
          this.qrExpiration = data.qr_expiration;
        } else {
          this.paymentStatus = "error";
          throw data.message;
        }
      } catch (e) {
        console.error(e);
      }

      if (!this.hasQrCode) {
        this.timeout = setTimeout(() => {
          this.getQrCode();
        }, 10000);
      }
    },

    copyQrContentToClipboard() {
      var input = document.createElement("input");
      input.setAttribute("value", this.qrCode);
      document.body.appendChild(input);
      input.select();
      var result = document.execCommand("copy");
      document.body.removeChild(input);

      bus.$emit("show-notification", [
        "success",
        "",
        "Código copiado para a area de transferencia",
      ]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.order-complete-boleto {
  color: #3a3a3a;

  max-width: 510px;
  flex-direction: column;
  flex: 1;
  justify-content: center;

  .progress {
    border-radius: 5px;
    margin: 15px 0;
  }

  .ocb-title {
    font-weight: 700;
    // padding-bottom: 7.5px;
  }
  .ocb-barcode {
    font-weight: bold;
    font-size: 15px;
    padding-bottom: 5px;
    width: 100%;
    border: none;
    background: transparent;
  }

  .ocb-code-area {
    flex: 1 1 auto;
    align-self: center;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    justify-items: center;

    .oca-qrcode {
      display: flex;
      flex-direction: column;
      flex: 0 1 auto;
      padding-bottom: 15px;
      margin: 0 30px;

      .qrcode {
        padding: 10px 0px;
        // align-self: center;
      }
    }

    .oca-barcode {
      flex: 1 1 420px;
      padding: 20px;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #eeeeee;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      max-width: 790px;
    }
  }

  .ocb-waiting {
    align-self: center;
    font-size: 15px;
    font-family: sans-serif;
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #eeeeee;
    border: 1px solid #e5e5e5;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .ocb-copy-code {
    cursor: pointer;
    color: var(--brand-primary, $brand-primary);
    font-weight: bold;
    font-size: 14px;

    &:hover {
      color: var(--brand-accent, $brand-accent);
    }
  }

  .ocb-footer {
    margin: 25px 0;

    button {
      width: 100%;
    }
  }
}
</style>
